var map = {
	"./0B.png": 3968,
	"./0G.png": 597,
	"./0R.png": 5023,
	"./0Y.png": 3956,
	"./1B.png": 7683,
	"./1G.png": 7958,
	"./1R.png": 9950,
	"./1Y.png": 6606,
	"./2B.png": 7193,
	"./2G.png": 333,
	"./2R.png": 288,
	"./2Y.png": 4096,
	"./3B.png": 5967,
	"./3G.png": 932,
	"./3R.png": 6108,
	"./3Y.png": 7103,
	"./4B.png": 519,
	"./4G.png": 4401,
	"./4R.png": 862,
	"./4Y.png": 7077,
	"./5B.png": 9610,
	"./5G.png": 1237,
	"./5R.png": 155,
	"./5Y.png": 4870,
	"./6B.png": 4023,
	"./6G.png": 2343,
	"./6R.png": 1941,
	"./6Y.png": 8718,
	"./7B.png": 2340,
	"./7G.png": 164,
	"./7R.png": 9868,
	"./7Y.png": 6589,
	"./8B.png": 4742,
	"./8G.png": 6184,
	"./8R.png": 3116,
	"./8Y.png": 5553,
	"./9B.png": 6886,
	"./9G.png": 1077,
	"./9R.png": 3511,
	"./9Y.png": 1278,
	"./D2B.png": 1678,
	"./D2G.png": 5995,
	"./D2R.png": 3743,
	"./D2Y.png": 5177,
	"./D4W.png": 394,
	"./W.png": 836,
	"./_B.png": 4812,
	"./_G.png": 4896,
	"./_R.png": 3291,
	"./_Y.png": 3580,
	"./skipB.png": 6103,
	"./skipG.png": 5312,
	"./skipR.png": 9644,
	"./skipY.png": 7227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6733;